import { render, staticRenderFns } from "./UpdateAnimalNumberModal.vue?vue&type=template&id=55fa9aa2&scoped=true&"
import script from "./UpdateAnimalNumberModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateAnimalNumberModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateAnimalNumberModal.vue?vue&type=style&index=0&id=55fa9aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa9aa2",
  null
  
)

export default component.exports